import { useStoredIds } from './useStoredIds';

/** Enough for every notice a person could close; the oldest drop off first. */
const KEEP = 20;

/**
 * Notices the viewer closed, remembered on this device only. Losing them brings a notice back, which is the safe way
 * to fail. Give each notice an id that changes when it should return (a trial's end date, say), rather than clearing
 * old ids.
 */
export function useDismissed() {
  const { has, set } = useStoredIds('timato.dismissed', KEEP);
  return { isDismissed: has, dismiss: (id: string) => set(id, true) };
}
